<template>
  <div>
    <el-card shadow="hover" :class="{'answer-option': true, 'disabled': readonly}">
      <el-form ref="form" :inline="true" :hide-required-asterisk="true" label-width="40px" :rules="rules" :model="data">
        <el-row>
          <el-col :xs="16" :sm="12" :lg="6">
            <el-form-item label="序号" prop="Index">
              <el-input placeholder="请输入序号" size="mini" :disabled="readonly" v-model="data.Index" oninput="value=value.replace(/[^0-9]/g,'')"
                onblur="value=!!value?value.toNumber().toFixedEx(0):null" />
            </el-form-item>
          </el-col>
          <el-col :xs="16" :sm="12" :lg="6">
            <el-form-item label="值" prop="Value">
              <el-input v-if="valueType === GLOBAL.enumQuestionnaireValueType.Int32" placeholder="请输入值" size="mini" :disabled="readonly" v-model="data.Value"
                oninput="value=value.replace(/[^0-9]/g,'')" onblur="value=!!value?value.toNumber().toFixedEx(0):null" />
              <el-input v-else placeholder="请输入值" size="mini" :disabled="readonly" v-model="data.Value" />
            </el-form-item>
          </el-col>
          <el-col :xs="20" :sm="16" :lg="10">
            <el-form-item label="文本" prop="Label">
              <el-input placeholder="请输入文本" size="mini" :disabled="readonly" v-model="data.Label" />
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item>
              <el-button v-if="!readonly" type="text" class="btn-delete" @click="onDeleteClick">删除</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>

<script>
const mixin_generalMethods = {
  methods: {
    validate() {
      let isValid = true;

      let refForm = this.$refs.form;
      if (!!refForm) {
        refForm.validate((valid) => {
          isValid = valid;
        });
      }

      return isValid;
    },
    clearValidate() {
      let refForm = this.$refs.form;
      if (!!refForm) {
        refForm.clearValidate();
      }
    },
  },
};

export default {
  name: "answerOption",
  mixins: [mixin_generalMethods],
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    valueType: {
      type: Number,
      default: 0,
    },
    data: {
      type: Object,
      required: true,
    },
    customValidator: {
      type: Function,
      default: null,
    },
  },
  data() {
    const indexValidator = (rule, value, callback) => {
      let message = "";

      if (!!this.customValidator) {
        let fixedValue = `${value}`.toNumber();
        let fieldName = "Index";
        let result = this.customValidator(fixedValue, fieldName, this.data);
        if (!!result[fieldName] && !result[fieldName].success) {
          message = result[fieldName].message;
        }
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    const valueValidator = (rule, value, callback) => {
      let message = "";

      if (!!this.customValidator) {
        let fixedValue = `${value}`;
        let fieldName = "Value";
        let result = this.customValidator(fixedValue, fieldName, this.data);
        if (!!result[fieldName] && !result[fieldName].success) {
          message = result[fieldName].message;
        }
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      rules: {
        Index: [
          {
            required: true,
            message: "请输入序号",
            trigger: "blur",
          },
          {
            validator: indexValidator,
            trigger: "blur",
          },
        ],
        Label: [
          {
            required: true,
            message: "请输入文本",
            trigger: "blur",
          },
        ],
        Value: [
          {
            required: true,
            message: "请输入值",
            trigger: "blur",
          },
          {
            validator: valueValidator,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    onDeleteClick() {
      this.$confirm("您确定要删除该回答选项吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.$emit("delete", this.data);
        })
        .catch(() => {});
    },
  },
  watch: {
    data(newVal, oldVal) {
      this.$nextTick(() => {
        this.clearValidate();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.answer-option {
  padding: 0 10px;
  margin-bottom: 5px;

  &.disabled {
    .el-form-item {
      /deep/ .el-form-item__content {
        padding-bottom: 0;
      }
    }
  }

  /deep/ .el-card__body {
    padding: 0;
  }

  .el-form-item {
    /deep/ .el-form-item__label {
      margin-bottom: 0;
    }

    /deep/ .el-form-item__content {
      width: calc(100% - 40px);
      padding-bottom: 20px;
    }

    .el-input {
      /deep/ .el-input__inner {
        padding: 0 5px;
      }
    }
  }

  .btn-delete {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/questionnaire/answerOption.vue